export default "__VITE_ASSET__Dx6L5dxH__"